export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/phone-left.8524f05c-cdbd78.png";